import { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuthStore } from '../stores/authStore';

export function useTimezoneDetection() {
  const {user} = useAuthStore();
  
  useEffect(() => {
    if (!user?.id) return;
    
    const detectAndSaveTimezone = async () => {
      try {
          const currentUserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // Only set if not already set
        if (!user?.timezone || user.timezone !== currentUserTimezone) {
          
          await supabase
            .from('profiles')
            .update({ timezone: currentUserTimezone })
            .eq('id', user.id);
          
          // console.log('Timezone auto-detected and saved:', currentUserTimezone);
        }
      } catch (error) {
        console.error('Error auto-detecting timezone:', error);
      }
    };
    
    detectAndSaveTimezone();
  }, [user?.id]);
}